import { RoutePath } from "@mirage/webapp/routeTypes";
import { useAtomValue } from "jotai";
import { useLocation } from "react-router-dom";
import { stackChatSidebarOpenAtom } from "../atoms/chatSidebarAtoms";
import { useStackChatSources } from "./FullScreenStackHooks";

// Whether we should show the Dash chat sidebar. Returns true if all of the following are true:
// - the current page is not an embed stack page (ie, dash.ai)
// - the chat sidebar is open
// - there are chat sources (ie, chat is enabled)
export function useShowDashChatSidebar() {
  const { pathname } = useLocation();
  const isStackChatSidebarOpen = useAtomValue(stackChatSidebarOpenAtom);
  const { hasChatSources } = useStackChatSources();
  const isEmbedStackPage = pathname.includes(RoutePath.EMBED_STACKS);
  return isStackChatSidebarOpen && hasChatSources && !isEmbedStackPage;
}
